export default __webpack_public_path__ + "static/media/eth-xnft-black.23089740.svg";